import { render, staticRenderFns } from "./UnConfirmedCard.vue?vue&type=template&id=4c64f2a2&scoped=true&"
import script from "./UnConfirmedCard.vue?vue&type=script&lang=js&"
export * from "./UnConfirmedCard.vue?vue&type=script&lang=js&"
import style0 from "./UnConfirmedCard.vue?vue&type=style&index=0&id=4c64f2a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c64f2a2",
  null
  
)

export default component.exports